import React from 'react';
import { clsx } from 'clsx';
import styles from './index.module.scss';
import Image from '@/src/shared/components/Image';
import { translations } from './translations';

const logos = [
  {
    title: 'Inman',
    style: 'inman',
    image: '/images/landing-images/publishers/publisher-inman.png',
  },
  {
    title: 'Forbes',
    style: 'forbes',
    image: '/images/landing-images/publishers/publisher-forbes.png',
  },
  {
    title: 'Bloomberg',
    style: 'bloomberg',
    image: '/images/landing-images/publishers/bloomberg.png',
  },
  {
    title: 'Business Insider',
    style: 'businessinsider',
    image: '/images/landing-images/publishers/business-insider.png',
  },
  {
    title: 'Housing Wire',
    style: 'housingwire',
    image: '/images/landing-images/publishers/housingwire.png',
  },
  {
    title: 'TechCrunch',
    style: 'techcrunch',
    image: '/images/landing-images/publishers/publisher-techcrunch.png',
  },
  {
    title: 'National Association of Realtors®',
    style: 'nar',
    image: '/images/landing-images/publishers/publisher-nar.png',
  },
];

export default function CompanyLogo({
  isGray = false,
  className,
  classes,
  hideTitle,
  language = 'en',
}: {
  isGray?: boolean;
  className?: string;
  hideTitle?: boolean;
  language?: keyof typeof translations;
  classes?: {
    title?: string;
  };
}) {
  return (
    <div className={clsx(styles.container, className)}>
      {!hideTitle && (
        <div
          className={clsx(
            classes?.title,
            styles.appeared,
            'home__logos__appeared'
          )}
        >
          {translations[language].title}
        </div>
      )}

      <div className={clsx(styles.logos, 'home__logos__logos')}>
        {logos.map((logo) => (
          <div className={styles.item} key={logo.title}>
            <div
              className={clsx(
                styles.logo,
                styles[logo.style],
                !!isGray && styles.gray
              )}
            >
              <Image
                fill
                src={logo.image}
                alt={logo.title}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
